import { createStore } from "vuex";
import auth from './auth/index'
import selectedMessage from "./selectedMessage";
import sysMessage from "./sysMessage";
import newAd from "./newAd";
import overlay from "./overlay";
import loadingBar from "./loadingBar";
export default createStore({
  state: {
    sidebarType: "bg-white",
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    layout: "default",
    activeAds: 0
  },
  mutations: {
  },
  actions: {
  },
  getters: {},
  modules: {
    auth, 
    selectedMessage,
    sysMessage,
    newAd,
    overlay,
    loadingBar
  }
});
